import { render, staticRenderFns } from "./GroupChangeList.vue?vue&type=template&id=6d22cad3&"
import script from "./GroupChangeList.vue?vue&type=script&lang=js&"
export * from "./GroupChangeList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports